module.exports = __webpack_public_path__ + "static/media/folder.9323fe4d.svg";